function slideUp(elem, animationTime = 400, callback) {
  elem.style.display = 'block';
  elem.style.transition = `height ${animationTime}ms ease-out`;
  elem.style.overflow = 'hidden';
  elem.style.height = `${elem.scrollHeight}px`;

  setTimeout(function(){
    elem.classList.add('u-height-0');
  }, 1);

  setTimeout(function(){
    if (typeof callback === 'function') {
      callback();
    }

    elem.style.overflow = '';
    elem.style.display = '';
    elem.style.height = '';
    elem.classList.remove('u-height-0');
  }, animationTime+1);
}

function slideDown(elem, animationTime = 400, callback) {
  elem.style.transition = '';
  elem.style.height = 0;
  elem.style.overflow = 'hidden';
  elem.style.display = 'block';
  elem.style.transition = `height ${animationTime}ms ease-out`;
  elem.style.height = `${elem.scrollHeight}px`;

  setTimeout(function(){
    elem.style.height = '';
    elem.style.overflow = '';

    if (typeof callback === 'function') {
      callback();
    }

    elem.style.display = '';
  }, animationTime);
}

export { slideUp, slideDown };
